import { buildTimeConfig } from 'config'
import { SignupContainer } from 'modules/auth/components/SignupForm/SignupContainer'
import { getSignupStaticProps } from 'modules/auth/lib/signup/getStaticProps'
import { EnumSignupType } from 'modules/auth/types/signup'
import { Seo } from 'modules/common/components/Seo/Seo'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { EnumRoutes } from 'modules/common/routes'
import { BlankPage } from 'modules/common/types/page'
import { GetStaticProps } from 'next'
import { useRouter } from 'next/router'

export const ManagementOfferSignupPage: BlankPage = () => {
  const { t } = useTranslation('auth-page-signup')

  const router = useRouter()

  if (!buildTimeConfig.signupConfig.canAccessManagementOffer) {
    router.replace(EnumRoutes.SIGNUP)
  }

  return (
    <>
      <Seo title={t('meta.title')} description={t('meta.description')} />
      <SignupContainer signupType={EnumSignupType.STRICTLY_MANAGEMENT_TOOLS} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: await getSignupStaticProps(locale as string),
})

ManagementOfferSignupPage.type = 'notAuthenticated'
export default ManagementOfferSignupPage
